import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from './AuthContext';
import { useAdminAuth } from './AdminAuthContext';
import LoginPopup from './LoginPopup';
import CreateUserPopup from './CreateUserPopup';
import CreateAdminPopup from './CreateAdminPopup';
import '../components/css/Header.css';

function Header() {
  const { user, logout } = useAuth();
  const { admin, adminLogout } = useAdminAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showCreateUserPopup, setShowCreateUserPopup] = useState(false);
  const [showCreateAdminPopup, setShowCreateAdminPopup] = useState(false);
  const menuRef = useRef();
  const location = useLocation();

  useEffect(() => {
    const handler = (e) => {
      if (mobileMenuOpen && menuRef.current && !menuRef.current.contains(e.target)) {
        setTimeout(() => setMobileMenuOpen(false), 100);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [mobileMenuOpen]);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const handleLogout = () => {
    admin ? adminLogout() : logout();
  };

  return (
    <>
      <header className="site-header">
        <div className="header-inner">
        {/* Brand */}
        <div className="leftH">
          <Link to="/" className="link cosmos-brand" aria-label="Cosmos-Station home">
            <img src="/cosmos-station-mark.svg" alt="" className="cosmos-brand-mark" />
            <span>Cosmos<span className="cosmos-brand-dash">-</span>Station</span>
          </Link>
        </div>

        {/* Center Navigation (desktop only) */}
        <div className="centerH desktop-nav">
          <NavLink to="/" className={({ isActive }) => `link ${isActive ? 'active' : ''}`} end><div className="headerItem">Home</div></NavLink>
          <NavLink to="/Services" className={({ isActive }) => `link ${isActive ? 'active' : ''}`}><div className="headerItem">Validators</div></NavLink>
          <NavLink to="/valservices" className={({ isActive }) => `link ${isActive ? 'active' : ''}`}><div className="headerItem">Services</div></NavLink>
          <NavLink to="/stats" className={({ isActive }) => `link ${isActive ? 'active' : ''}`}><div className="headerItem">Chain Stats</div></NavLink>
          <a
            href="https://www.luncscan.com"
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            <div className="headerItem">LuncScan</div>
          </a>
          <a href="https://statsbin.com/" target="_blank" rel="noopener noreferrer" className="link">
            <div className="headerItem">Stats Bin</div>
          </a>

        

          {!user && !admin && (
            <button type="button" className="link headerItem" onClick={() => setShowLoginPopup(true)}>Login</button>
          )}

          {user && (
            <>
              <Link to="/Validatorinfo" className="link"><div className="headerItem">Validator Node Setup</div></Link>
              <button type="button" className="link headerItem" onClick={handleLogout}>Logout</button>
            </>
          )}

          {admin && (
            <>
              <Link to="/admin/visitor-logs" className="link"><div className="headerItem">Visitor Logs</div></Link>
              <Link to="/admin-panel" className="link"><div className="headerItem">Admin Panel</div></Link>              <button type="button" className="link headerItem" onClick={handleLogout}>Logout</button>
            </>
          )}
        </div>

        {/* Right Side: mobile menu */}
        <div className="rightH">
          <button type="button" className="menu-container" aria-label={mobileMenuOpen ? "Close menu" : "Open menu"} aria-expanded={mobileMenuOpen} aria-controls="site-mobile-menu" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            <span className={`hamburger-icon ${mobileMenuOpen ? 'open' : ''}`}>☰</span>
          </button>
        </div>
        </div>

        {/* ✅ Mobile Nav Dropdown */}
        {mobileMenuOpen && (
          <nav className="mobile-nav" id="site-mobile-menu" ref={menuRef} aria-label="Mobile navigation">
            <NavLink to="/" className={({ isActive }) => `link ${isActive ? 'active' : ''}`} end>Home</NavLink>
            <NavLink to="/Services" className={({ isActive }) => `link ${isActive ? 'active' : ''}`}>Validators</NavLink>
            <NavLink to="/valservices" className={({ isActive }) => `link ${isActive ? 'active' : ''}`}>Services</NavLink>
            <NavLink to="/stats" className={({ isActive }) => `link ${isActive ? 'active' : ''}`}>Chain Stats</NavLink>
            <a
              href="https://www.luncscan.com"
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              LuncScan
            </a>
            <a href="https://statsbin.com/" target="_blank" rel="noopener noreferrer" className="link">Stats Bin</a>


            {!user && !admin && (
              <button type="button" className="link" onClick={() => setShowLoginPopup(true)}>Login</button>
            )}

            {user && (
              <>
                <Link to="/Validatorinfo" className="link">Validator Node Setup</Link>
                <button type="button" className="link" onClick={handleLogout}>Logout</button>
              </>
            )}

            {admin && (
              <>
                <Link to="/admin/visitor-logs" className="link">Visitor Logs</Link>
                <Link to="/admin-panel" className="link">Admin Panel</Link>                <button type="button" className="link" onClick={handleLogout}>Logout</button>
              </>
            )}
          </nav>
        )}
      </header>

      {/* Popups */}
      {showLoginPopup && (
        <LoginPopup
          onClose={() => setShowLoginPopup(false)}
          openCreateUserPopup={() => { setShowLoginPopup(false); setShowCreateUserPopup(true); }}
          openCreateAdminPopup={() => { setShowLoginPopup(false); setShowCreateAdminPopup(true); }}
          openResetPasswordPopup={() => setShowLoginPopup(false)}
        />
      )}
      {showCreateUserPopup && <CreateUserPopup onClose={() => setShowCreateUserPopup(false)} />}
      {showCreateAdminPopup && <CreateAdminPopup onClose={() => setShowCreateAdminPopup(false)} />}
    </>
  );
}

export default Header;
